import Icons from '@/const/icons';
import { QuestionType } from '@/interfaces';

export const getQuestionIcon = (questionType: QuestionType): string => {
	const parseIcons: Record<QuestionType, string> = {
		DATE: Icons.calendar,
		TEXT: Icons.textAlignCenter,
		YES_NO: Icons.question,
		MULTIPLE: Icons.checkSquareOffset,
	};
	return parseIcons[questionType];
};

export const getTitleFromQuestionType = (
	questionType: QuestionType
): string => {
	const parseTitles: Record<QuestionType, string> = {
		DATE: 'Date',
		TEXT: 'Short Answer',
		YES_NO: 'Yes/No',
		MULTIPLE: 'Multiple Choice',
	};
	return parseTitles[questionType];
};
